// extracted by mini-css-extract-plugin
export default {"link":"qL-z","disabled":"rL-z"};